import React from 'react'
import PropTypes from 'prop-types'
import {
  stepLengthHorizontal,
  stepLengthVertical,
  lineWidth,
  stepIconSize
} from './ProgressBarConstants'

Line.propTypes = {
  backgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  zIndex: PropTypes.number,
  vertical: PropTypes.bool
}

const verticalStyles = {
  width: lineWidth,
  height: stepLengthVertical,
  marginLeft: stepIconSize / 2,
  transform: 'translateX(-50%)',
  marginTop: -1,
  marginBottom: -1
}

const horizontalStyles = {
  width: stepLengthHorizontal,
  height: lineWidth,
  marginTop: stepIconSize / 2,
  transform: 'translateY(-50%)',
  marginLeft: -1,
  marginRight: -1
}

function Line({ backgroundColor, zIndex, vertical }) {
  const responsiveStyles = vertical ? verticalStyles : horizontalStyles
  return (
    <div
      style={{
        backgroundColor,
        zIndex,
        ...responsiveStyles
      }}
    />
  )
}

export default Line
